import { IconArrowDown, IconArrowUp, color, csx } from '@vtex/admin-ui'
import React from 'react'
import type { RefObject } from 'react'

type InStoreListArrowProps = {
  show?: boolean
  direction: 'up' | 'down'
  itemsContainerRef: RefObject<HTMLDivElement>
}

export const InStoreListArrow = ({
  show,
  direction,
  itemsContainerRef,
}: InStoreListArrowProps) => {
  const isUp = direction === 'up'

  return (
    <div
      className={csx({
        position: 'sticky',
        display: 'flex',
        justifyContent: 'center',
        zIndex: 1,
        bottom: !isUp ? 0 : undefined,
        top: isUp ? 0 : undefined,
        background: `linear-gradient(to ${
          isUp ? 'top' : 'bottom'
        }, rgba(255, 255, 255, 0) 0%, ${color('$gray05')} 100%)`,
        ...(show
          ? {}
          : { display: 'none', visibility: 'hidden', maxHeight: '0px' }),
      })}
    >
      <button
        onClick={() => {
          if (!itemsContainerRef.current) {
            return
          }

          // Arrow up should add a negative offset (scroll up)
          const offset =
            (isUp ? -1 : 1) * itemsContainerRef.current.offsetHeight

          itemsContainerRef.current?.scroll({
            top: itemsContainerRef.current?.scrollTop + offset,
            behavior: 'smooth',
          })
        }}
        className={csx({
          border: '$neutral',
          borderRadius: '50%',
          padding: '$space-2',
          margin: '$space-2',
          color: '$blue40',
          backgroundColor: 'white',

          // Flex button otherwise arrows get display: inline and become
          // elongated
          display: 'flex',
        })}
      >
        {isUp ? <IconArrowUp /> : <IconArrowDown />}
      </button>
    </div>
  )
}
